import { UnixTime } from 'types/measurement/time'
import { parseNumber, parseString } from 'utils/parsingHelpers'

import { GeckoEntryBase } from './geckoEntry'
import { RolodexEntryJson } from './rolodexEntryFields'

export type UserComment = {
  user_id: string
  user_name: string | undefined
  timestamp: UnixTime
  text: string
}

export class GeckoUserComment extends GeckoEntryBase<
  UserComment,
  {
    organization: string
    site: string
  }
> {
  private constructor(json: RolodexEntryJson) {
    super(
      json,
      {
        user_id: parseString(json.data.user_id) ?? 'unknown',
        user_name: parseString(json.data.user_name),
        timestamp: parseNumber(json.data.timestamp) as UnixTime,
        text: parseString(json.data.text) ?? '',
      },
      {
        organization: parseString(json.tags.organization) ?? '',
        site: parseString(json.tags.site) ?? '',
      },
      {}
    )
  }

  public static CreateFromJSON(json: RolodexEntryJson): GeckoUserComment {
    return new GeckoUserComment(json)
  }
}
